import React, { ReactElement, ReactNode } from 'react';
import classNames from 'classnames/bind';
import styles from './RiskProductsTooltip.module.scss';

const cx = classNames.bind(styles);

interface RiskProductsTooltipProps {
  id: string;
  positionLeft: number;
  positionTop: number;
  children: ReactNode;
}

const RiskProductsTooltip = ({ positionLeft, positionTop, id, children }: RiskProductsTooltipProps): ReactElement => {
  const chartComponentPosition = document.getElementById(id)?.getBoundingClientRect();
  const componentLeft = chartComponentPosition?.left || 0;
  const componentTop = chartComponentPosition?.top || 0;
  const dynamicStyles: React.CSSProperties = {
    left: `${componentLeft + positionLeft}px`,
    top: `${componentTop + window.scrollY + positionTop}px`,
  };

  return (
    <div className={cx('body')} style={dynamicStyles} data-testid="risk-products-tooltip">
      {children}
      <div className={cx('triangle')} />
    </div>
  );
};

export default RiskProductsTooltip;
